const products = [
  {
    id: 1,
    image: "https://m.media-amazon.com/images/I/81ktY42I9KL._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/40AgjrX",
  },
  {
    id: 2,
    image: "https://m.media-amazon.com/images/I/91kRn82BaXL._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/406wixQ",
  },
  {
    id: 3,

    image: "https://m.media-amazon.com/images/I/81qvTj-2r9L._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/4rlSlvP",
  },
  {
    id: 4,

    image: "https://m.media-amazon.com/images/I/71IWHOnEyKL._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/3ZYSjPd",
  },
  {
    id: 5,
    image: "https://m.media-amazon.com/images/I/710leMrUIpL._AC_SY450_.jpg",
    amazonLink: "https://amzn.to/3OCGUSI",
  },
  {
    id: 6,
    image: "https://m.media-amazon.com/images/I/71vcMt5IrGL._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/4tWjE2d",
  },
  {
    id: 7,

    image: "https://m.media-amazon.com/images/I/61RcZNSpuDL._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/4cO3xgU",
  },
  {
    id: 8,

    image: "https://m.media-amazon.com/images/I/610J7rjiA6L._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/4cSGYHS",
  },
  {
    id: 9,
    image: "https://m.media-amazon.com/images/I/71jaibBVAQL._AC_SX679_.jpg",
    amazonLink: "https://amzn.to/3P7imBf",
  },
   {
    id: 10,
    image: "https://instagram.fdel88-1.fna.fbcdn.net/v/t51.82787-15/622000650_18037958243741104_3051899678075147576_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=105&_nc_cb=04374bf5-24e287ff&ig_cache_key=MzE3MDYyMzM1OTcwMzgwNTA0Mg%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjYxMng2MTIuc2RyLkMzIn0%3D&_nc_ohc=b4PtfRkzKt8Q7kNvwF5OQEb&_nc_oc=AdkIcrBNBR0I-onwaMfHNRwQq3cg4AaSFi6L7zZlJ9U7itKZ7_jRAsfjAdvG7bpe6Eg&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=instagram.fdel88-1.fna&_nc_gid=Lx2fZJ2hMpOUJ0V84nQDgQ&_nc_ss=8&oh=00_AfuTx1p_IUvGlnwjulQ-YNvjuy4uRp-B_Lag9YbcVjYm4A&oe=69A8B39E",
    amazonLink: "https://www.canadapetcare.com/",
  },

  {
    id: 11,
    image: "https://m.media-amazon.com/images/I/81FQQyc1KBL._SX466_.jpg",
    amazonLink: "https://amzn.to/46tEXy6",
  },

   {
    id: 12,
    image: "https://m.media-amazon.com/images/I/81fRxzPr1xL._SX466_.jpg",
    amazonLink: "https://amzn.to/4rH2PXk",
  },

     {
    id: 13,
    image: "  https://m.media-amazon.com/images/I/716fRQVia+L._SX466_.jpg",
    amazonLink: "https://amzn.to/4kXYDjq",
  },

     {
    id: 14,
    image: "https://m.media-amazon.com/images/I/81y1AcRVQ4L._SX466_.jpg",
    amazonLink: "https://amzn.to/4r2SXWS",
  },


     {
    id: 15,
    image: "  https://m.media-amazon.com/images/I/81X50+3ZgSL._SX466_.jpg",
    amazonLink: "https://amzn.to/4aRO0tP",
  },
  

     {
    id: 16,
    image: "https://m.media-amazon.com/images/I/81a3TN9hsvL._SX466_.jpg",
    amazonLink: "https://amzn.to/3OHOpro",
  },
  

     {
    id: 17,
    image: "https://m.media-amazon.com/images/I/61h8mGU1KeL._SX679_.jpg",
    amazonLink: "https://amzn.to/47gpQIp",
  },

     {
    id: 18,
    image: "https://m.media-amazon.com/images/I/71ZvCpTr9cL._SX679_.jpg",
    amazonLink: "https://amzn.to/40C2rxo",
  },

     {
    id: 19,
    image: "https://m.media-amazon.com/images/I/81bOnCW7YOL._SX466_.jpg",
    amazonLink: "https://amzn.to/3OFYRQj",
  },
   {
    id: 20,
    image: "https://m.media-amazon.com/images/I/71g+yOIFg0L._SX679_.jpg",
    amazonLink: "https://amzn.to/40ztp8O",
  },
    {
    id: 21,
    image: "https://m.media-amazon.com/images/I/61E+64yzDqL._SX466_.jpg",
    amazonLink: "https://amzn.to/4bbHAXT",
  },
      {
    id: 22,
    image: "https://m.media-amazon.com/images/I/714gwTY2MrL._SX679_.jpg",
    amazonLink: "https://amzn.to/46APK9I",
  },
      {
    id: 23,
    image: "https://m.media-amazon.com/images/I/71vcG2FwCVL._SX679_.jpg",
    amazonLink: "https://amzn.to/4aWkWBE",
  },
     {
    id: 24,
    image: "https://m.media-amazon.com/images/I/71TFGa21w9L._SX466_.jpg",
    amazonLink: "https://amzn.to/4bkDxrl",
  },
   {
    id: 25,
    image: "https://m.media-amazon.com/images/I/61GLXK0gLrL._SX679_.jpg",
    amazonLink: "https://amzn.to/4skNmMI",
  },
   {
    id: 26,
    image: "https://m.media-amazon.com/images/I/71m1MBOaMkL._SX466_.jpg",
    amazonLink: "https://amzn.to/4rAT9O6",
  },
];

export default products;
